// extracted by mini-css-extract-plugin
export default {"messageContainer":"BotMessage_messageContainer__HT0jm","avatar":"BotMessage_avatar__ElmrG","messageBubble":"BotMessage_messageBubble__yQ9OC"};